import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Gasstation-index-1992f2b851e6b27d1-1'),
    routerUrl: '/Gasstation',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Gasstation')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Gasstation-index-1992f2b851e6b27d1-2'),
        routerUrl: '/GasstationForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./GasstationForm')),
      },
      //$MORE$
    ],
  },
];
